import VueRouter from "vue-router";
import store from '../store/index'

// import HelloWorld from '../components/HelloWorld.vue'
import Dashboard from '../components/Dashboard.vue'
import Arena from '../components/Arena.vue'

import Charts from '../components/Charts.vue'
import DynamicCharts from '../components/DynamicCharts.vue'
import login from '../components/login.vue'

import Store from '../store';

import createUser from '../components/createUser.vue'

import TrainingApp from '../training-app/App.vue'
import UserMGMT from "../components/UserMGMT";

import notFound from "../components/theme/notFound"
import permissionDenied from "../components/theme/permissionDenied"
import profile from "../components/profile"
import resetPassword from "../components/resetPassword";
import mapbox from "../components/mapbox";
import help from "../components/theme/help"
import Maintenance from "../components/theme/Maintenance"

const index = [
    // {path: '/', component: Dashboard},
    {path: '/', component: login},
    {path: '/create-user/', component: createUser},
    {path: '/create-user/login', component: createUser},
    {path: '/login/', component: login},
    // {path: '/maintenance', component: Maintenance},
    // {path: '/charts', component: DynamicCharts, name: 'charts'},
    {path: '/dashboard/:slug', component: Dashboard},
    {path: '/dashboard', component: Dashboard, name: 'dashboard'},
    // {path: '/login', component: Maintenance, name: 'login'},
    // // {path: '/login', component: login, name: 'login'},
    {path: '/arena/', component: Arena, name: 'arena'},
    // {path: '/dyno', component: DynamicCharts},
    // {path: '/maps', component: mapbox},
    // // {path: '/invite-portal', component: InvitePortal},
    // {path: '/profile/', component: profile},
    {path: '/invited/', component: createUser},
    // {path: '/training', component: TrainingApp},
    // {path: '/user-mgmt/', component: UserMGMT},
    // {path: '/404', component: notFound},
    // {path: '/403', component: permissionDenied},
    {path: '/reset-password', component: resetPassword, name: 'reset-password'},
    {path: '/reset-password/:token', component: resetPassword, name: 'reset-password'},
    {path: '/help', component: help, name: 'help'},
    // {path: '*', redirect: '/maintenance' },
    {path: '*', component: login }
    
    

]


const router = new VueRouter({
    mode: 'history',
    routes: index
})


// router.beforeEach((to, from, next) => {
//
// 	switch (to.name) {
// 		case 'arena':
//     console.log(store)
// 			// let permissions = store.getters.permissions_list;
// 			// const authorized = !!(permissions.indexOf('see-arena') + 1)
//       //   console.log("ARENA ATTEMPT", permissions,  false)
// 			next();
//
//
// 		default:
// 			next();
// 	}
//
// })
//



export default router;

